module.exports = __webpack_public_path__ + "media/images/emblems/AltoMalcantone-coat_of_arms-90067cdc6df446757043522667ff4eb4.svg";